import type { SVGProps } from "react";
import { memo } from "react";
const PersonalHealthDashboard = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#B0084D" />
        <stop offset="100%" stopColor="#FF4F8B" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M13 42.997h2v-2h-2zm34.954-17.296a1 1 0 0 0-.951-.702H47a1 1 0 0 0-.953.697l-6.284 19.751-5.882-10.923a1 1 0 0 0-.868-.526H33a1 1 0 0 0-.868.504l-3.712 6.496H17v2h12a1 1 0 0 0 .868-.505l3.106-5.434 6.145 11.412a1.002 1.002 0 0 0 1.834-.17l6.039-18.976 4.054 12.971a1 1 0 0 0 .954.701h15v-2H52.736zm-7.951 37.666L25.606 44.785l-1.58 1.225L39.21 65.608c.189.245.46.423.79.387a1 1 0 0 0 .788-.384l15.293-19.599-1.576-1.23zM14.717 34.079C13.566 31.964 13 29.842 13 27.71 13 20.149 19.299 14 27.04 14c6.191 0 10.976 2.8 12.96 7.2 1.985-4.4 6.77-7.2 12.96-7.2C60.702 14 67 20.15 67 27.709c0 2.09-.549 4.184-1.633 6.224-.318.601-.702 1.203-1.172 1.835l-.881 1.043-2.571 2.856-1.486-1.338 3.373-3.805c.369-.499.699-1.015.969-1.527C64.53 31.247 65 29.47 65 27.71c0-6.457-5.401-11.71-12.04-11.71C47.007 16 41 19.094 41 26a.999.999 0 1 1-2 0c0-6.906-6.007-10-11.96-10C20.402 16 15 21.253 15 27.71c0 1.796.485 3.596 1.439 5.354l3.404 5.316-1.685 1.078z"
      />
    </g>
  </svg>
);
const Memo = memo(PersonalHealthDashboard);
export default Memo;
